import type {
  CuratedCopy,
  PreviewFacts,
  PreviewBeat,
} from "./preview-copy.types";
import { formattedScoreLabel } from "./preview-beats";
import { cadenceOf } from "./preview-cadence";
import { item } from "./preview-marquee";
function generalsCompetitionBeats(f: PreviewFacts): PreviewBeat[] {
  const freeForAll = f.seats !== 2;
  const cadencePhrase = cadenceOf(f.roundMinutes).cadencePhrase;
  const label = formattedScoreLabel(f.scoreLabel);
  const scoreWord =
    label.toLowerCase() === "mmr" ? "MMR (a matchmaking rating)" : label;
  return [
    {
      title: "The match",
      body: freeForAll
        ? "Three to eight players start with one general each on a fresh map; capture enemy generals and protect your own to outlast the field."
        : "Two players start with one general each on a fresh 18–21 by 18–21 map; capture the enemy general to win.",
    },
    {
      title: "One move a turn",
      body:
        "Each turn your program sends army from a tile it holds to a " +
        "neighbour, or passes, seeing only its own tiles and the eight " +
        "around each, and you take a tile only with the larger force.",
    },
    {
      title: "How you score",
      body: freeForAll
        ? "Survival ranks the winner and players with kills above kill-less players, then ranks each group by reverse elimination order."
        : "The winner scores +1 and the loser −1; at the 2,000-tick bot limit, both score zero.",
    },
    {
      title: "The ladder",
      body: `Standings rank players by ${scoreWord} across rounds${cadencePhrase ? `, one ${cadencePhrase}` : ""}.`,
    },
  ];
}
export const generalsCompetitionCopy: CuratedCopy = {
  blurb:
    "Three to eight generals, one hidden map. Grow armies, capture castles, and take rival generals while protecting your own. Free-for-all is the main league; Classic 1v1 and Build 1v1 are also available.",
  closingLine:
    "Generals.io is a fast-paced, multiplayer browser strategy game played on a 2D grid.",
  marquee: [
    item({
      mark: "people",
      label: "3–8 PLAYER FREE-FOR-ALL",
    }),
    item({
      mark: "run",
      label: "FRESH BOARD EACH EPISODE",
    }),
    item({
      mark: "trophy",
      label: "NEUTRAL CASTLES",
    }),
    item({
      mark: "minus",
      label: "NO CASTLE BUILDING",
    }),
    item({
      mark: "track",
      label: "SURVIVAL PLACEMENTS",
    }),
    item({
      mark: "people",
      label: "BASIC OR CONTAINERS",
    }),
  ],
  included: {
    description:
      "Press Play and ask your AI coding assistant to build your first generals.io bot. It writes the code; your bot plays the matches.",
  },
  beats: generalsCompetitionBeats,
  team: {
    title: "Team",
    subtitle: "Equilibre × ÚFAL",
    href: "https://www.generals.bot/about",
  },
  rulesLicenseNotice: {
    text: "Rules text adapted from generals-bots, MIT License, © 2024 Matej Straka.",
    href: "https://github.com/strakam/generals-bots/blob/master/LICENSE",
  },
  replayStageUnfit: true,
  replayViewerSize: { width: 960, height: 640 },
};
